var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useCallback, useMemo } from "react";
import { useFetchUser, useHasAuthCookie, useLogout } from "../rx/useAuth";
import { Button } from "../../components/Form";
import { getHashOrPath, redirectToPage } from "../../helpers/redirectToPage";
import { useSelector } from "react-redux";
import { getIntegrationURL } from "../../store/stateGetter";
import { ERoute } from "../../helpers/Routes";
import { useTranslation } from "react-i18next";
import { USER_SIGN_IN, USER_AUTHENTICATED, USER_NEEDS_TO_PAY, USER_AUTHENTICATED_MENU } from "../../classConstants";
import { Menu, MenuPopoverComponent } from "../../components/Form/Menu/Menu";
import { MenuItem } from "../../components/Form/Menu/MenuItem";
import parse from 'html-react-parser';
import styled from "styled-components";
import { getClassName } from "../../helpers";
import { useEnableUserAccountFloatingPreview, useIsUserAccountsEnabled } from "../rx/useIsUserAccountsEnabled";
import { withConditionalHook } from "../../hoc/withConditionalHook";
var useNavigateTo = function (route) {
    var integrationUrl = useSelector(getIntegrationURL);
    return useCallback(function () {
        redirectToPage(getHashOrPath(route, integrationUrl));
    }, [integrationUrl, route]);
};
var AuthenticatedUser = styled(memo(function (props) {
    var t = useTranslation().t;
    var name = props.name;
    var email = props.email;
    var dueAmount = +props.due_amount;
    var dueAmountFormatted = props.due_amount_formatted;
    var logout = useLogout();
    var navigateToUserAccount = useNavigateTo(ERoute.USER_ACCOUNT);
    var label = useMemo(function () {
        return parse(t("authentication.preview.user", {
            name: name,
            email: email,
            dueAmount: dueAmount <= 0
                ? t("authentication.preview.due_amount_empty", { dueAmount: dueAmountFormatted })
                : "<span class=\"" + USER_NEEDS_TO_PAY + "\">" + dueAmountFormatted + "</span>",
        }));
    }, [t, name, dueAmount, dueAmountFormatted]);
    var buttonProps = useMemo(function () { return ({
        className: getClassName(props.className, USER_AUTHENTICATED),
        variant: "primary"
    }); }, [props.className]);
    return (React.createElement(StyledMenu, { name: "user", placement: "auto-end", label: label, className: USER_AUTHENTICATED_MENU, buttonProps: buttonProps, autoWidth: true },
        React.createElement(MenuItem, { caption: t("authentication.preview.my_account"), onClick: navigateToUserAccount }),
        React.createElement("hr", null),
        React.createElement(MenuItem, { caption: t("authentication.preview.sign_out"), onClick: logout })));
}))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .", " {\n        color: var(--ws-user-requires-payment-color, var(--ws-danger-text));\n    }\n"], ["\n    .", " {\n        color: var(--ws-user-requires-payment-color, var(--ws-danger-text));\n    }\n"])), USER_NEEDS_TO_PAY);
var UserAuthButtonComponent = memo(function () {
    var hasCookies = useHasAuthCookie();
    var user = useFetchUser();
    var t = useTranslation().t;
    var navigateToUseSignin = useNavigateTo(ERoute.USER_ACCOUNT);
    if (hasCookies && !user)
        return null;
    if (!user) {
        return React.createElement(Button, { className: USER_SIGN_IN, onClick: navigateToUseSignin }, t("authentication.preview.sign_in"));
    }
    ;
    return React.createElement(AuthenticatedUser, __assign({}, user));
});
export var UserAuthButton = withConditionalHook(UserAuthButtonComponent, useIsUserAccountsEnabled);
export var FloatingUserAuthButton = withConditionalHook(UserAuthButton, useEnableUserAccountFloatingPreview);
var StyledMenu = styled(Menu)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    hr { margin: 0 }\n    display: inline-flex;\n    flex-direction: column;\n\n    ", " {\n        margin-top: 0;\n        padding: 0;\n    }\n\n    ", " {\n        padding: var(--ws-user-account-menu-option-padding, .3em);\n        cursor: pointer;\n    }\n"], ["\n    hr { margin: 0 }\n    display: inline-flex;\n    flex-direction: column;\n\n    ", " {\n        margin-top: 0;\n        padding: 0;\n    }\n\n    ", " {\n        padding: var(--ws-user-account-menu-option-padding, .3em);\n        cursor: pointer;\n    }\n"])), MenuPopoverComponent, MenuItem);
var templateObject_1, templateObject_2;
